import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import './Policies.css';

function TermsConditions() {
  return (
    <Container className="policy-page py-5">
      <h1 className="text-center mb-5">Kullanım Koşulları</h1>
      
      <Row className="g-4">
        <Col lg={8} className="mx-auto">
          <Card className="policy-card">
            <Card.Body>
              <section className="mb-5">
                <h4>Genel Hükümler</h4>
                <p>
                  Mr. Brown web sitesini kullanarak aşağıdaki kullanım koşullarını kabul etmiş sayılırsınız. 
                  Bu koşulları kabul etmiyorsanız, lütfen sitemizi kullanmayınız.
                </p>
              </section>

              <section className="mb-5">
                <h4>Üyelik ve Hesap Güvenliği</h4>
                <ul className="policy-list">
                  <li>Sitemize üye olurken verdiğiniz bilgilerin doğru ve güncel olması gerekmektedir.</li>
                  <li>Hesap bilgilerinizin güvenliğinden siz sorumlusunuz.</li>
                  <li>Hesabınızla yapılan tüm işlemlerden siz sorumlusunuz.</li>
                  <li>Şüpheli bir durum fark ettiğinizde derhal müşteri hizmetlerimize bildiriniz.</li>
                </ul>
              </section>

              <section className="mb-5">
                <h4>Fikri Mülkiyet Hakları</h4>
                <p>
                  Sitemizdeki tüm içerik (logolar, tasarımlar, metinler, görseller vb.) Mr. Brown'a aittir 
                  ve telif hakları ile korunmaktadır. İzinsiz kullanımı yasaktır.
                </p>
              </section>

              <section className="mb-5">
                <h4>Ürün ve Fiyatlandırma</h4>
                <ul className="policy-list">
                  <li>Ürün fiyatları ve özellikleri önceden haber verilmeksizin değiştirilebilir.</li>
                  <li>Fiyatlara KDV dahildir.</li>
                  <li>Kampanyalar stoklarla sınırlıdır.</li>
                  <li>Hatalı fiyat veya ürün bilgisi durumunda sipariş iptal edilebilir.</li>
                </ul>
              </section>

              <section className="mb-5">
                <h4>Sipariş ve Teslimat</h4>
                <ul className="policy-list">
                  <li>Siparişler ödeme onayından sonra işleme alınır.</li>
                  <li>Teslimat süreleri ürün türüne göre değişiklik gösterebilir.</li>
                  <li>Özel tasarım ürünlerde üretim süresi eklenecektir.</li>
                  <li>Teslimat adresi bilgilerinin doğruluğundan müşteri sorumludur.</li>
                </ul>
              </section>

              <section className="mb-5">
                <h4>İade ve İptal</h4>
                <ul className="policy-list">
                  <li>İade koşulları İade Politikamızda belirtilmiştir.</li>
                  <li>Özel tasarım ürünlerde iade kabul edilmemektedir.</li>
                  <li>Sipariş iptali sadece sipariş hazırlama aşamasında mümkündür.</li>
                </ul>
              </section>

              <section>
                <h4>Uyuşmazlık ve Yetki</h4>
                <p>
                  Bu kullanım koşullarından doğabilecek her türlü uyuşmazlıkta Türk Hukuku uygulanacak olup, 
                  Antalya Mahkemeleri ve İcra Daireleri yetkilidir.
                </p>
                <p className="mt-4">
                  Bu kullanım koşulları en son {new Date().toLocaleDateString('tr-TR')} tarihinde güncellenmiştir. 
                  Koşullar önceden haber verilmeksizin değiştirilebilir.
                </p>
              </section>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default TermsConditions;